import { IGetCostsQueryParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQuery.type';
import { queryOptions } from '@tanstack/react-query';
import { getOtherCostsFunction } from './getOtherCostsQueryFunction.ts';
import { GetOtherCostsQueryResponseType } from './getOtherCostsQuery.types.ts';

export const getOtherShowCostsQueryOptions = (params: IGetCostsQueryParams) => {
  return queryOptions({
    queryKey: ['costs', params],
    queryFn: () => getOtherCostsFunction(params),
    select: (data: GetOtherCostsQueryResponseType) => {
      return {
        totalPrice: data?.parts_damage_total,
        showCosts: [],
      };
    },
  });
};
